import { useEffect } from 'react';
// import { useHistory } from 'react-router-dom';
// import { useDispatch } from 'react-redux';

import { AuthService } from 'app/services';
// import { userLoggedOut } from 'app/auth/store/userSlice';

function SignoutCallback() {
  // const history = useHistory();
  // const dispatch = useDispatch();

  useEffect(() => {
    // let timeout;
    AuthService.signoutRedirectCallback();
    /* .then(user => {
        // dispatch(userLoggedOut());
        // timeout = setTimeout(() => {
        //   history.push('/welcome');
        // }, 1500);
      })
      .catch(error => console.log(error)); */

    // return () => {
    //   clearTimeout(timeout);
    // };
  }, []);

  return <div></div>;
}

export default SignoutCallback;
